import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/redux/store';

export const goodsStateSelector = ({ goods }: RootState) => goods;

export const goodsState = createSelector(goodsStateSelector, (goods) => goods);
